// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1fmWa","footer":"ModalCreateQualiphyProcedure_footer__32Rzt","additionData":"ModalCreateQualiphyProcedure_additionData__187w5"};